const rankingItems = [
  { rank: 1, name: '久久视频', desc: '综合热度最高，视频资源最丰富的在线视频网站', trend: 'up', score: '9.8' },
  { rank: 2, name: '芒果视频', desc: '视频播放器在线看视频体验优质，更新频率稳定', trend: 'up', score: '9.6' },
  { rank: 3, name: '97视频', desc: '本月访问量大幅增长，视频资源覆盖广度持续提升', trend: 'up', score: '9.4' },
  { rank: 4, name: '丝瓜视频', desc: '精品视频资源丰富，在线视频网站用户口碑优异', trend: 'stable', score: '9.2' },
  { rank: 5, name: '蓝莓视频', desc: '新晋热门在线视频网站，视频播放器在线看视频体验佳', trend: 'up', score: '9.0' },
  { rank: 6, name: '91在线视频', desc: '经典在线视频网站资源平台，持续稳定提供视频资源', trend: 'stable', score: '8.8' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          热门榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          久久视频、芒果视频、97视频等在线视频网站热度排名，视频播放器在线看视频资源综合评分
        </p>
        <div className="space-y-3">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-background-100 rounded-xl border border-background-200/70 p-4 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-bold text-foreground-800 whitespace-nowrap">{item.name}</h3>
                  {item.trend === 'up' && (
                    <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                  )}
                  {item.trend === 'stable' && (
                    <i className="ri-subtract-line text-foreground-400 text-sm"></i>
                  )}
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 text-right">
                <span className="text-lg font-bold text-primary-500">{item.score}</span>
                <span className="text-xs text-foreground-400 block">综合评分</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}